import { render, staticRenderFns } from "./SystemSecurityTab.vue?vue&type=template&id=2328a8ac&"
import script from "./SystemSecurityTab.vue?vue&type=script&lang=js&"
export * from "./SystemSecurityTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports